module.exports = __webpack_public_path__ + "static/media/logo.3381923d.svg";